/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Update Registration Flow with Profile Method
 */
export interface UpdateRegistrationFlowWithProfileMethod { 
    /**
     * The Anti-CSRF Token  This token is only required when performing browser flows.
     */
    csrf_token?: string;
    /**
     * Method  Should be set to profile when trying to update a profile.
     */
    method: string;
    /**
     * Screen requests navigation to a previous screen.  This must be set to credential-selection to go back to the credential selection screen. credential-selection RegistrationScreenCredentialSelection nolint:gosec // not a credential previous RegistrationScreenPrevious
     */
    screen?: UpdateRegistrationFlowWithProfileMethod.ScreenEnum;
    /**
     * Traits  The identity\'s traits.
     */
    traits: object;
    /**
     * Transient data to pass along to any webhooks
     */
    transient_payload?: object;
}
export namespace UpdateRegistrationFlowWithProfileMethod {
    export type ScreenEnum = 'credential-selection' | 'previous';
    export const ScreenEnum = {
        CredentialSelection: 'credential-selection' as ScreenEnum,
        Previous: 'previous' as ScreenEnum
    };
}


